/**
 * @desc 通过用户编码查询
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  Array<defs.appCenter.BizSecondaryAdminConfigResponseDto>
>;
export function request(userCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/bizSecondaryAdminConfig/${userCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
